<template>
  <div class="main">
    <my_menu></my_menu>

    <div class="content">
      <div class="tree_div">
        <Tree :data="tree_data" @on-select-change="tree_change"> </Tree>
      </div>
      <div class="table_div">
        <div class="options">
          <div class="options_txt">
            <span class="dep_name_id">部门ID：{{ tree_model }}</span>
            <Input
              v-model="tree_name"
              placeholder="请输入部门名称..."
              size="small"
              style="width: 120px; margin-left: 10px"
              @on-enter="enter_dep_name"
            />
            <Input
              v-model="project_dep_id"
              placeholder="请输入项目部门id."
              size="small"
              style="width: 220px; margin-left: 10px"
              @on-enter="enter_project_dep_id"
            />
          </div>
          <div>
            <Button
              style="font-size: 10px; margin-right: 10px"
              size="small"
              @click="add_dep_show = true"
              type="primary"
              icon="md-add"
              >添加新部门</Button
            >
            <Button
              style="font-size: 10px; margin-right: 10px"
              size="small"
              @click="add_user_show = true"
              type="primary"
              icon="md-add"
              >添加用户</Button
            >
            <Button
              style="font-size: 10px; margin-right: 10px"
              size="small"
              @click="add_auth_show = true"
              type="primary"
              icon="md-add"
              >添加权限</Button
            >
            <Button
              style="font-size: 10px; margin-right: 10px"
              size="small"
              @click="click_transfer_dep"
              type=""
              icon="md-repeat"
              >转移部门</Button
            >
            <Button
              style="font-size: 10px; margin-right: 10px"
              size="small"
              @click="del_dep"
              type="error"
              icon="ios-trash-outline"
              >删除部门</Button
            >
          </div>
        </div>
        <Table
          size="small"
          :columns="columns"
          :data="user_list"
          :height="windowHeight - 100"
          @on-selection-change="table_selection_change"
        >
          <template #user_role_list="{ row }">
            <div class="user_role_box">
              <Tag
                color="success"
                v-for="(item, i) in row.user_role_list"
                :key="String(i)"
                :name="String(i)"
                closable
                @on-close="subtract_role(row, item)"
                >{{ item.name }}</Tag
              >
            </div>
          </template>
          <template #avatar="{ row }">
            <div class="avatar_div" @click="update_avatar(row)">
              <Avatar :src="row.avatar" />
            </div>
          </template>

          <template #data_dep="{ row }">
            <span
              :title="row.data_dep"
              :class="tree_model == row.data_dep ? 'current_dep' : 'current_dep2'"
            >
              {{ row.data_dep }} -
              {{ tree_model == row.data_dep ? "本部门" : "其他" }}</span
            >
            <Icon
              @click="click_update_data_dep(row)"
              class="click_update_data_dep"
              type="ios-create-outline"
            />
          </template>
        </Table>
      </div>
    </div>

    <Modal width="420" v-model="add_auth_show" title="添加新权限" :footer-hide="true">
      <div class="select_box">
        选择角色：
        <Select v-model="select_role_id" style="width: 200px">
          <OptionGroup :label="k" v-for="(v, k) in options_dict" :key="k">
            <Option :value="oitem.value" v-for="(oitem, oindex) in v" :key="oindex">{{
              oitem.label
            }}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="button_box">
        <Button type="primary" @click="affirm_add_role">确认添加</Button>
      </div>
    </Modal>

    <Modal
      width="420"
      v-model="update_data_show"
      title="更新数据归属"
      :footer-hide="true"
    >
      <div class="select_box">
        输入部门id：
        <Input
          v-model="update_data_dep_data.data_dep"
          placeholder="输入部门id"
          style="width: 300px"
        />
      </div>
      <div class="button_box">
        <Button type="primary" @click="affirm_update_dep">确认添加</Button>
      </div>
    </Modal>

    <Modal width="420" v-model="add_dep_show" title="添加新部门" :footer-hide="true">
      <div class="select_box">
        部门名字：
        <Input v-model="add_dep_name" placeholder="输入部门名字" style="width: 300px" />
      </div>
      <div class="button_box">
        <Button type="primary" @click="affirm_add_new_dep">确认添加</Button>
      </div>
    </Modal>

    <Modal width="420" v-model="add_user_show" title="添加用户" :footer-hide="true">
      <div class="select_box">
        用户id：
        <Input v-model="add_user_id" placeholder="输入用户id" style="width: 300px" />
      </div>
      <div class="button_box">
        <Button type="primary" @click="affirm_add_user">确认添加</Button>
      </div>
    </Modal>

    <Modal
      width="420"
      v-model="transfer_department_show"
      title="转移部门"
      :footer-hide="true"
    >
      <div class="select_box12">
        选中用户：

        {{ table_selection.length }}人
      </div>
      <div class="select_box">
        部门id：
        <Input
          v-model="transfer_department_id"
          placeholder="输入部门id"
          style="width: 300px"
        />
      </div>
      <div class="button_box">
        <Button type="primary" @click="transfer_ok">确认转移</Button>
      </div>
    </Modal>

    <Modal width="420" v-model="update_avatar_show" title="更新头像" :footer-hide="true">
      <div>
        <Upload
          ref="avatar_update"
          :action="update_avatar_upload_url + update_avatar_user_id"
          :on-success="success_avatar"
        >
          <Button icon="ios-cloud-upload-outline">上传头像</Button>
        </Upload>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      tree_data: [],
      tree_model: "",
      columns: [],
      user_list: [],

      update_avatar_show: false,
      update_avatar_user_id: "",
      update_avatar_upload_url:
        process.env.VUE_APP_HOST +
        "/user_manage/update_avatar?token=" +
        this.$cookies.get("admin_token") +
        "&user_id=",

      // 添加权限
      add_auth_show: false,
      select_role_id: "",
      //角色数据
      options_dict: [],

      table_selection: [],

      update_data_dep_data: {
        user_id: "",
        data_dep: "",
      },
      update_data_show: false,
      add_user_show: false,
      add_user_id: "",
      transfer_department_show: false,
      transfer_department_id: "",
      transfer_department_user_id_list: [],

      tree_name: "",
      project_dep_id:'',
      

      add_dep_show: false,
      add_dep_name: "",
    };
  },

  mounted() {
    this.window_change();
    this.get_farmework_list();
    this.get_role_options();
  },

  methods: {
    affirm_add_new_dep() {
      var that = this;
      var obj = {
        parent_dep_id: this.tree_model,
        name: this.add_dep_name,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/framework/dep_add", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.get_farmework_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.transfer_department_show = false;
          console.log(res, "请求出错");
        });
    },

    enter_dep_name(e) {
      console.log(e);
      this.update_dep_name();
    },
    enter_project_dep_id(e) {
      console.log(e);
      this.update_project_dep_id();
    },
    update_project_dep_id(e) {
      var that = this;
      var obj = {
        dep_id: this.tree_model,
        project_dep_id: this.project_dep_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/dep_project_dep_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.get_farmework_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.transfer_department_show = false;
          console.log(res, "请求出错");
        });
    },

    update_dep_name(e) {
      var that = this;
      var obj = {
        dep_id: this.tree_model,
        name: this.tree_name,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/dep_name_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.get_farmework_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.transfer_department_show = false;
          console.log(res, "请求出错");
        });
    },

    del_dep(e) {
      var that = this;
      var obj = {
        dep_id: this.tree_model,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/framework/del_dep", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.get_farmework_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.transfer_department_show = false;
          console.log(res, "请求出错");
        });
    },

    success_avatar(e) {
      this.$refs.avatar_update.clearFiles();
      this.$Message.success(e.msg);
      this.update_avatar_show = false;
      this.get_department_user();
    },

    update_avatar(item) {
      this.update_avatar_user_id = item.user_id;
      this.update_avatar_show = true;
    },

    //确认转移
    transfer_ok() {
      var that = this;
      var obj = {
        user_id_list: this.transfer_department_user_id_list,
        dep_id: this.transfer_department_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/transfer_dep",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.transfer_department_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.transfer_department_show = false;
          console.log(res, "请求出错");
        });
    },

    click_transfer_dep() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }

      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }
      console.log(user_id_list);

      this.transfer_department_show = true;
      this.transfer_department_user_id_list = user_id_list;
    },

    //确认添加
    affirm_add_user() {
      var that = this;
      var obj = {
        dep_id: this.tree_model,
        user_id: this.add_user_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/dep_add_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.add_user_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.add_user_show = false;
          console.log(res, "请求出错");
        });
    },

    affirm_update_dep() {
      var that = this;
      var obj = {
        data_dep: this.update_data_dep_data.data_dep,
        user_id: this.update_data_dep_data.user_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/update_user_data_dep",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.update_data_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_data_dep(item) {
      console.log(item);
      this.update_data_dep_data.user_id = item.user_id;
      this.update_data_dep_data.data_dep = item.data_dep;
      this.update_data_show = true;
    },

    table_selection_change(e) {
      this.table_selection = e;
      console.log(e);
    },

    //确认添加权限
    affirm_add_role() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }
      if (this.select_role_id == "") {
        this.$Message.error("请选择角色");
        return;
      }
      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }
      console.log(user_id_list);

      var that = this;
      var obj = {
        role_id: this.select_role_id,
        user_id_list: user_id_list,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/add_role", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
            that.add_auth_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取角色列表
    get_role_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/user_manage/role_option", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.options_dict = res.data.options_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //减少权限
    subtract_role(row, item) {
      var that = this;
      var obj = {
        role_id: item.role_id,
        user_id: row.user_id,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/subtract_role", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_department_user();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //
    tree_change(e) {
      console.log(e);
      if (e.length > 0) {
        this.tree_model = e[0]["dep_id"];
        this.tree_name = e[0]["name"];
        this.project_dep_id = e[0]['project_dep_id']
        this.get_department_user();
      }
    },

    //获取部门用户列表
    get_department_user() {
      var that = this;
      var obj = {
        dep_id: this.tree_model,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/department_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_list = res.data.user_list;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取组织架构列表
    get_farmework_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/framework/department",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.tree_data = res.data.tree_list;
            that.tree_data[0]["selected"] = true;
            that.tree_model = res.data.tree_list[0]["dep_id"];
            that.tree_name = res.data.tree_list[0]["name"];
            that.get_department_user();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.current_dep {
  color: #fff;
  padding: 2px 2px;
  background: green;
}

.current_dep2 {
  color: #fff;
  padding: 2px 2px;
  background: rgb(255, 0, 55);
}

.click_update_data_dep {
  color: #ccc;
  margin-left: 3px;
  cursor: pointer;
}

.click_update_data_dep:hover {
  font-size: 15px;
  color: #0466dd;
}

.dep_name_id {
  color: #333;
}

.button_box {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}

.select_box {
  justify-content: center;
  display: flex;
  align-items: center;
}

.select_box12 {
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding-left: 15px;
  margin-bottom: 10px;
}
.table_div {
  background-color: #fff;
  height: calc(100vh - 20px);
  overflow: auto;
  width: 100%;
  padding: 10px;
}

.tree_div {
  height: calc(100vh - 20px);
  background: #fff;
  overflow: auto;
  padding: 10px;
  width: 200px;
  flex-shrink: 0;
  margin-right: 10px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 220px);
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
  display: flex;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
